<template>
  <VRow
    justify="center"
    align="center"
    no-gutters
    class="fill-height fill-height"
  >
    <VCol lg="6" md="8" cols="12">
      <v-container>
        <div :class="`d-flex justify-${alignment}`">
          <v-card v-if="submissionStore.intro" flat style="max-width: 768px">
            <v-card-title v-if="submissionStore.intro.iconURL">
              <v-img
                :src="submissionStore.intro.iconURL"
                aspect-ratio="1"
                max-height="160px"
              />
            </v-card-title>
            <v-card-title
              v-if="submissionStore.intro.heading"
              :class="`justify-${alignment} text-${alignment} font-weight-bold`"
            >
              <TipTapRenderer :value="submissionStore.intro.heading" />
            </v-card-title>
            <v-card-text
              v-if="submissionStore.intro.text"
              :class="`text-${alignment} mt-4 text-body-1`"
            >
              <TipTapRenderer :value="submissionStore.intro.text" />
            </v-card-text>
            <v-card-text>
              <v-row :justify="alignment" class="mt-4">
                <v-col :class="`text-${alignment}`">
                  <v-btn
                    :ripple="false"
                    :loading="loading"
                    data-cy="start"
                    size="large"
                    @click="start()"
                  >
                    {{ $t('Intro.start') }}
                  </v-btn>
                </v-col>
              </v-row>
              <div
                v-if="
                  submissionStore.intro.timeEstimate && submissionStore.time
                "
                :class="`justify-${alignment} text-subtitle-2 text-${alignment} mt-3`"
              >
                <v-icon color="primary" start>mdi-clock-outline</v-icon>
                {{
                  $tc('Intro.takesToComplete', submissionStore.time, {
                    mins: submissionStore.time,
                  })
                }}
              </div>
            </v-card-text>
          </v-card>
        </div>
      </v-container>
    </VCol>
  </VRow>
</template>

<script lang="ts">
import { onKeyStroke } from '@vueuse/core';
import { mapStores } from 'pinia';
import { defineComponent } from 'vue';
import { useSubmissionStore } from '@/stores/submission';
import TipTapRenderer from '@/components/inputs/VTipTap/TipTapRenderer.vue';

export default defineComponent({
  name: 'IntroPage',
  components: { TipTapRenderer },
  data: () => ({
    loading: false,
  }),
  computed: {
    ...mapStores(useSubmissionStore),
    alignment() {
      return this.submissionStore.intro?.alignment ?? 'center';
    },
  },
  created() {
    onKeyStroke('Enter', () => {
      this.start();
    });
  },
  methods: {
    async start() {
      this.loading = true;
      await this.submissionStore.start();
      this.loading = false;
    },
  },
});
</script>
